const CONFIG = {
  ALGOLIA_APP_ID: process.env.GATSBY_ALGOLIA_APP_ID,
  ALGOLIA_APP_INDEX: process.env.GATSBY_ALGOLIA_APP_INDEX,
  ALGOLIA_APP_KEY: process.env.GATSBY_ALGOLIA_APP_KEY,
  API_URL: process.env.GATSBY_API_URL || '/api',
  DASHBOARD_URL: process.env.GATSBY_DASHBOARD_URL || '',
  DATADOG_APP_ID: process.env.GATSBY_DATADOG_APP_ID,
  DATADOG_HOST: process.env.GATSBY_DATADOG_HOST || 'datadoghq.eu',
  DATADOG_SERVICE_NAME:
    process.env.GATSBY_DATADOG_SERVICE_NAME || 'smarty-front-end',
  DATADOG_TOKEN: process.env.GATSBY_DATADOG_TOKEN,
  GROUP_PLANS_VOUCHER_CODE: process.env.GATSBY_GROUP_PLANS_VOUCHER_CODE,
  INTERCOM_APP_ID: process.env.GATSBY_INTERCOM_APP_ID,
  INTERCOM_TOKEN: process.env.GATSBY_INTERCOM_TOKEN,
  MARKETING_URL: process.env.GATSBY_MARKETING_URL || '',
  PAYPAL_DISPLAYNAME: process.env.GATSBY_PAYPAL_DISPLAYNAME,
  RAF_OFFER_AMOUNT: process.env.GATSBY_RAF_OFFER_AMOUNT || '10',
  SMARTY_ENV: process.env.GATSBY_SMARTY_ENV,
  VERSION: process.env.GATSBY_VERSION,
  GOOGLE_PAY_ENV: process.env.GATSBY_GOOGLE_PAY_ENV || 'TEST',
  ONE_TRUST_COOKIE_POLICY_SCRIPT_ID:
    process.env.GATSBY_ONE_TRUST_COOKIE_POLICY_SCRIPT_ID,

  CONTENTFUL_SPACE: process.env.GATSBY_CONTENTFUL_SPACE,
  CONTENTFUL_ENV: process.env.GATSBY_CONTENTFUL_ENV,
  CONTENTFUL_DELIVERY_API_TOKEN:
    process.env.GATSBY_CONTENTFUL_DELIVERY_API_TOKEN,
  CONTENTFUL_PREVIEW_API_TOKEN: process.env.GATSBY_CONTENTFUL_PREVIEW_API_TOKEN,
  CONTENTFUL_HOST: process.env.GATSBY_CONTENTFUL_HOST,
}

// Env vars are strings - so we need to check that vars are defined and that the string is `true`
const FEATURES = {
  DYNAMIC_HOMEPAGE_BANNER:
    process.env.GATSBY_FEATURE_DYNAMIC_HOMEPAGE_BANNER === 'true',
  RAF_OFFER: process.env.GATSBY_FEATURE_RAF_OFFER === 'true',
  RAF_OFFER_VOUCHER: process.env.GATSBY_FEATURE_RAF_VOUCHER_OFFER === 'true',
  PAYPAL_EXPRESS: process.env.GATSBY_FEATURE_PAYPAL_EXPRESS === 'true',
  APPLE_PAY: process.env.GATSBY_FEATURE_APPLE_PAY === 'true',
  GOOGLE_PAY: process.env.GATSBY_FEATURE_GOOGLE_PAY === 'true',
  REASONS_TO_LOVE: process.env.GATSBY_FEATURE_REASONS_TO_LOVE === 'true',
  ONE_TRUST_COOKIE_POLICY:
    process.env.GATSBY_FEATURE_ONE_TRUST_COOKIE_POLICY === 'true',
  DATA_ONLY_SIM_PHASE_2:
    process.env.GATSBY_FEATURE_DATA_ONLY_SIM_PHASE_2 === 'true',
  HUNDREDGB_PLAN: process.env.GATSBY_FEATURE_HUNDREDGB_PLAN === 'true',
}

const PATHS = {
  API_GROUP_PLANS_LOGGED_IN: `/plans?code=${CONFIG.GROUP_PLANS_VOUCHER_CODE}`,
  API_GROUP_PLANS: '/plans',
}

export { CONFIG, FEATURES, PATHS }
